var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#FDE0E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_648_51004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.494 18.92L10.136 18.122L15.876 8.21L17.22 9.008L11.494 18.92ZM10.08 14.51C9.268 14.51 8.638 14.2393 8.19 13.698C7.742 13.1473 7.518 12.41 7.518 11.486C7.518 10.562 7.742 9.82933 8.19 9.288C8.64733 8.74667 9.27733 8.476 10.08 8.476C10.8827 8.476 11.508 8.75133 11.956 9.302C12.4133 9.84333 12.642 10.5713 12.642 11.486C12.642 12.41 12.4133 13.1473 11.956 13.698C11.508 14.2393 10.8827 14.51 10.08 14.51ZM10.08 13.166C10.3507 13.166 10.5607 13.0353 10.71 12.774C10.8687 12.5033 10.948 12.074 10.948 11.486C10.948 10.898 10.8687 10.478 10.71 10.226C10.5607 9.96467 10.3507 9.834 10.08 9.834C9.8 9.834 9.58533 9.96 9.436 10.212C9.28667 10.464 9.212 10.8887 9.212 11.486C9.212 12.0927 9.28667 12.5267 9.436 12.788C9.58533 13.04 9.8 13.166 10.08 13.166ZM17.29 18.654C16.478 18.654 15.848 18.3833 15.4 17.842C14.952 17.2913 14.728 16.5493 14.728 15.616C14.728 14.692 14.952 13.964 15.4 13.432C15.8573 12.8907 16.4873 12.62 17.29 12.62C18.0927 12.62 18.718 12.8907 19.166 13.432C19.6233 13.9733 19.852 14.7013 19.852 15.616C19.852 16.5493 19.628 17.2913 19.18 17.842C18.732 18.3833 18.102 18.654 17.29 18.654ZM17.29 17.296C17.57 17.296 17.7847 17.1653 17.934 16.904C18.0833 16.6427 18.158 16.2133 18.158 15.616C18.158 15.0373 18.0787 14.6173 17.92 14.356C17.7707 14.0947 17.5607 13.964 17.29 13.964C17.01 13.964 16.7953 14.09 16.646 14.342C16.4967 14.594 16.422 15.0187 16.422 15.616C16.422 16.2227 16.4967 16.6567 16.646 16.918C16.7953 17.17 17.01 17.296 17.29 17.296Z",
    fill: "url(#paint0_linear_648_51004)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_648_51004",
    x: 6.51807,
    y: 7.21094,
    width: 16.334,
    height: 14.7109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.0392157 0 0 0 0 0.109804 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_648_51004"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_648_51004",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_648_51004",
    x1: 7,
    y1: 8.5,
    x2: 21.2364,
    y2: 8.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4112E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbv);
export default __webpack_public_path__ + "static/media/ABV.edcd3af211c68eebaf507c713b2b2410.svg";
export { ForwardRef as ReactComponent };